export const en = {
    "OK": "OK",
    "Cancel": "Cancel",
    "Keyword": "Keyword",
    "Search": "Search",
    "Reset": "Reset",
    "Name": "Name",
    "LocalizedName":"Localized Name",
    "Code": "Code",
    "Description": "Description",
    "Add": "Add",
    "Edit": "Edit",
    "Action": "Action"
}